import DefaultDemandDraft from "src/components/feature/ProjectDetailView/DemandDraft";

const DemandDraftView = () => {
  return <DefaultDemandDraft />;
};

export default DemandDraftView;
